const usphoneRE = new RegExp(
  '(\\+?1-?)?(\\([2-9]([02-9]\\d|1[02-9])\\)|' +
    '[2-9]([02-9]\\d|1[02-9]))-?[2-9]\\d{2}-?\\d{4}'
);

/**
 * Returns phone number format rule
 */
export const phoneNumberFormat = () => {
  return usphoneRE;
};

/**
 * Returns phone number mask format
 */
export const phoneNumberMask = () => {
  return '(999) 999-9999';
};

/**
 * Returns phone number max length rule
 */
export const phoneNumberMaxLength = () => {
  return 15;
};
